var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHostingdet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 722.445,
    height: 645.068,
    viewBox: "0 0 722.445 645.068",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_519",
    "data-name": "Rectangle 519",
    width: 722.445,
    height: 553.493
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_905",
    "data-name": "Group 905",
    transform: "translate(-1034.305 -786.932)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_880",
    "data-name": "Group 880",
    transform: "translate(1034.305 878.507)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_847",
    "data-name": "Group 847"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_841",
    "data-name": "Group 841",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1239",
    "data-name": "Path 1239",
    d: "M231.565,173.026H9.724a4.472,4.472,0,0,1-4.474-4.474V31.254A4.472,4.472,0,0,1,9.724,26.78h221.84a4.472,4.472,0,0,1,4.474,4.475v137.3a4.43,4.43,0,0,1-4.475,4.474",
    transform: "translate(12.412 63.316)",
    fill: "#140578"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_842",
    "data-name": "Group 842",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1240",
    "data-name": "Path 1240",
    d: "M6.2,157.446V33.842A3.532,3.532,0,0,1,9.732,30.31H227.1a3.532,3.532,0,0,1,3.533,3.532v123.6a3.532,3.532,0,0,1-3.533,3.533H9.732A3.532,3.532,0,0,1,6.2,157.446",
    transform: "translate(14.659 71.662)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_843",
    "data-name": "Group 843",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1241",
    "data-name": "Path 1241",
    d: "M76.584,30.6a2.927,2.927,0,1,1-2.927-2.927A2.929,2.929,0,0,1,76.584,30.6",
    transform: "translate(167.225 65.42)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_844",
    "data-name": "Group 844",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1242",
    "data-name": "Path 1242",
    d: "M73.714,30.6a2.927,2.927,0,1,1-2.927-2.927A2.929,2.929,0,0,1,73.714,30.6",
    transform: "translate(160.44 65.42)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_845",
    "data-name": "Group 845",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1243",
    "data-name": "Path 1243",
    d: "M70.844,30.6a2.927,2.927,0,1,1-2.927-2.927A2.929,2.929,0,0,1,70.844,30.6",
    transform: "translate(153.654 65.42)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_846",
    "data-name": "Group 846",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1244",
    "data-name": "Path 1244",
    d: "M32.207,45.559A11.809,11.809,0,1,1,20.4,33.75,11.8,11.8,0,0,1,32.207,45.559",
    transform: "translate(20.309 79.795)",
    fill: "#ffcc6e"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_525",
    "data-name": "Rectangle 525",
    width: 176.187,
    height: 5.585,
    transform: "translate(57.933 113.612)",
    fill: "#d6d4eb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_526",
    "data-name": "Rectangle 526",
    width: 119.937,
    height: 5.585,
    transform: "translate(57.933 122.561)",
    fill: "#d6d4eb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_527",
    "data-name": "Rectangle 527",
    width: 62.374,
    height: 5.585,
    transform: "translate(57.933 132.048)",
    fill: "#d6d4eb"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_849",
    "data-name": "Group 849"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_848",
    "data-name": "Group 848",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1245",
    "data-name": "Path 1245",
    d: "M32.207,56.749A11.809,11.809,0,1,1,20.4,44.94,11.8,11.8,0,0,1,32.207,56.749",
    transform: "translate(20.309 106.251)",
    fill: "#3da1b8"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_529",
    "data-name": "Rectangle 529",
    width: 176.187,
    height: 5.585,
    transform: "translate(57.933 151.258)",
    fill: "#d6d4eb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_530",
    "data-name": "Rectangle 530",
    width: 119.937,
    height: 5.585,
    transform: "translate(57.933 160.207)",
    fill: "#d6d4eb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_531",
    "data-name": "Rectangle 531",
    width: 62.374,
    height: 5.585,
    transform: "translate(57.933 169.661)",
    fill: "#d6d4eb"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_851",
    "data-name": "Group 851"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_850",
    "data-name": "Group 850",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1246",
    "data-name": "Path 1246",
    d: "M32.207,67.929A11.809,11.809,0,1,1,20.4,56.12,11.8,11.8,0,0,1,32.207,67.929",
    transform: "translate(20.309 132.684)",
    fill: "#ff5e63"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_533",
    "data-name": "Rectangle 533",
    width: 176.187,
    height: 5.585,
    transform: "translate(57.933 188.905)",
    fill: "#d6d4eb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_534",
    "data-name": "Rectangle 534",
    width: 119.937,
    height: 5.585,
    transform: "translate(57.933 197.82)",
    fill: "#d6d4eb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_535",
    "data-name": "Rectangle 535",
    width: 62.374,
    height: 5.585,
    transform: "translate(57.933 207.307)",
    fill: "#d6d4eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1247",
    "data-name": "Path 1247",
    d: "M79.261,73.5v3.028H76.2",
    transform: "translate(180.158 173.775)",
    fill: "none",
    stroke: "#38366e",
    strokeLinejoin: "round",
    strokeWidth: 1.049
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_100",
    "data-name": "Line 100",
    x1: 239.234,
    transform: "translate(11.068 250.303)",
    fill: "none",
    stroke: "#38366e",
    strokeLinejoin: "round",
    strokeWidth: 1.049,
    strokeDasharray: "2.967 2.967"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1248",
    "data-name": "Path 1248",
    d: "M4.541,76.528H1.48V73.5",
    transform: "translate(3.499 173.775)",
    fill: "none",
    stroke: "#38366e",
    strokeLinejoin: "round",
    strokeWidth: 1.049
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_101",
    "data-name": "Line 101",
    y1: 157.415,
    transform: "translate(4.979 83.67)",
    fill: "none",
    stroke: "#38366e",
    strokeLinejoin: "round",
    strokeWidth: 1.049,
    strokeDasharray: "3.058 3.058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1249",
    "data-name": "Path 1249",
    d: "M1.48,26.1V23.04H4.541",
    transform: "translate(3.499 54.473)",
    fill: "none",
    stroke: "#38366e",
    strokeLinejoin: "round",
    strokeWidth: 1.049
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_102",
    "data-name": "Line 102",
    x2: 239.234,
    transform: "translate(14.096 77.513)",
    fill: "none",
    stroke: "#38366e",
    strokeLinejoin: "round",
    strokeWidth: 1.049,
    strokeDasharray: "2.967 2.967"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1250",
    "data-name": "Path 1250",
    d: "M76.2,23.04h3.061V26.1",
    transform: "translate(180.158 54.473)",
    fill: "none",
    stroke: "#38366e",
    strokeLinejoin: "round",
    strokeWidth: 1.049
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_103",
    "data-name": "Line 103",
    y2: 157.449,
    transform: "translate(259.419 86.731)",
    fill: "none",
    stroke: "#38366e",
    strokeLinejoin: "round",
    strokeWidth: 1.049,
    strokeDasharray: "3.058 3.058"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_536",
    "data-name": "Rectangle 536",
    width: 9.958,
    height: 9.958,
    transform: "translate(0 72.534)",
    fill: "#140578"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_537",
    "data-name": "Rectangle 537",
    width: 9.958,
    height: 9.958,
    transform: "translate(0 245.324)",
    fill: "#140578"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_538",
    "data-name": "Rectangle 538",
    width: 9.958,
    height: 9.958,
    transform: "translate(254.44 72.534)",
    fill: "#140578"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_539",
    "data-name": "Rectangle 539",
    width: 9.958,
    height: 9.958,
    transform: "translate(254.44 245.324)",
    fill: "#38366e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1251",
    "data-name": "Path 1251",
    d: "M155.02,112.871V109.81h3.061",
    transform: "translate(366.51 259.622)",
    fill: "none",
    stroke: "#38366e",
    strokeLinejoin: "round",
    strokeWidth: 1.049
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_540",
    "data-name": "Rectangle 540",
    width: 7.704,
    height: 7.704,
    transform: "translate(517.695 365.563)",
    fill: "#38366e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_856",
    "data-name": "Group 856",
    transform: "translate(154.656 172.319)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1252",
    "data-name": "Path 1252",
    d: "M472.392,305.695H55.289a9.318,9.318,0,0,1-9.319-9.319V60.539a9.318,9.318,0,0,1,9.319-9.319h417.1a9.318,9.318,0,0,1,9.319,9.319V296.376a9.318,9.318,0,0,1-9.319,9.319",
    transform: "translate(-45.97 -51.22)",
    fill: "#140578"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1253",
    "data-name": "Path 1253",
    d: "M47.76,277.309V63.508a5.628,5.628,0,0,1,5.618-5.618H465.872a5.628,5.628,0,0,1,5.618,5.618v213.8a5.628,5.628,0,0,1-5.618,5.618H53.378a5.607,5.607,0,0,1-5.618-5.618",
    transform: "translate(-41.738 -35.45)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1254",
    "data-name": "Path 1254",
    d: "M180.625,58.437a5.517,5.517,0,1,1-5.517-5.517,5.5,5.5,0,0,1,5.517,5.517",
    transform: "translate(246.302 -47.201)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1255",
    "data-name": "Path 1255",
    d: "M175.2,58.437a5.517,5.517,0,1,1-5.517-5.517,5.5,5.5,0,0,1,5.517,5.517",
    transform: "translate(233.488 -47.201)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1256",
    "data-name": "Path 1256",
    d: "M169.785,58.437a5.517,5.517,0,1,1-5.518-5.517,5.5,5.5,0,0,1,5.518,5.517",
    transform: "translate(220.673 -47.201)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1257",
    "data-name": "Path 1257",
    d: "M101.022,95.08v3.061H97.96",
    transform: "translate(231.605 224.797)",
    fill: "none",
    stroke: "#38366e",
    strokeLinejoin: "round",
    strokeWidth: 1.049
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_104",
    "data-name": "Line 104",
    x1: 145.606,
    transform: "translate(177.768 322.938)",
    fill: "none",
    stroke: "#38366e",
    strokeLinejoin: "round",
    strokeWidth: 1.049,
    strokeDasharray: "3.059 3.059"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1258",
    "data-name": "Path 1258",
    d: "M54.071,98.141H51.01V95.08",
    transform: "translate(120.602 224.797)",
    fill: "none",
    stroke: "#38366e",
    strokeLinejoin: "round",
    strokeWidth: 1.049
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_105",
    "data-name": "Line 105",
    y1: 99.818,
    transform: "translate(171.612 213.599)",
    fill: "none",
    stroke: "#38366e",
    strokeLinejoin: "round",
    strokeWidth: 1.049,
    strokeDasharray: "3.114 3.114"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1259",
    "data-name": "Path 1259",
    d: "M51.01,64.658V61.63h3.061",
    transform: "translate(120.602 145.711)",
    fill: "none",
    stroke: "#38366e",
    strokeLinejoin: "round",
    strokeWidth: 1.049
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_106",
    "data-name": "Line 106",
    x2: 145.606,
    transform: "translate(180.864 207.341)",
    fill: "none",
    stroke: "#38366e",
    strokeLinejoin: "round",
    strokeWidth: 1.049,
    strokeDasharray: "3.059 3.059"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1260",
    "data-name": "Path 1260",
    d: "M97.96,61.63h3.062v3.028",
    transform: "translate(231.605 145.711)",
    fill: "none",
    stroke: "#38366e",
    strokeLinejoin: "round",
    strokeWidth: 1.049
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_107",
    "data-name": "Line 107",
    y2: 99.818,
    transform: "translate(332.626 216.828)",
    fill: "none",
    stroke: "#38366e",
    strokeLinejoin: "round",
    strokeWidth: 1.049,
    strokeDasharray: "3.114 3.114"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_541",
    "data-name": "Rectangle 541",
    width: 161.014,
    height: 115.597,
    transform: "translate(190.418 225.946)",
    fill: "#140578"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_858",
    "data-name": "Group 858"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_857",
    "data-name": "Group 857",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1261",
    "data-name": "Path 1261",
    d: "M157.534,84.98a13.76,13.76,0,1,1-13.76-13.76A13.755,13.755,0,0,1,157.534,84.98Zm42.592,78.926H59.6l44.274-83.5,33.273,57.361,22.574-23.819Z",
    transform: "translate(140.911 168.385)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_543",
    "data-name": "Rectangle 543",
    width: 200.578,
    height: 12.347,
    transform: "translate(369.97 209.124)",
    fill: "#d6d4eb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_544",
    "data-name": "Rectangle 544",
    width: 57.63,
    height: 6.157,
    transform: "translate(369.97 231.833)",
    fill: "#d6d4eb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_545",
    "data-name": "Rectangle 545",
    width: 23.382,
    height: 6.157,
    transform: "translate(435.472 231.833)",
    fill: "#d6d4eb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_546",
    "data-name": "Rectangle 546",
    width: 61.398,
    height: 6.157,
    transform: "translate(467.836 231.833)",
    fill: "#d6d4eb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_547",
    "data-name": "Rectangle 547",
    width: 36.469,
    height: 6.157,
    transform: "translate(534.079 231.833)",
    fill: "#d6d4eb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_548",
    "data-name": "Rectangle 548",
    width: 75.999,
    height: 6.157,
    transform: "translate(369.97 247.208)",
    fill: "#d6d4eb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_549",
    "data-name": "Rectangle 549",
    width: 29.572,
    height: 6.157,
    transform: "translate(454.379 247.208)",
    fill: "#d6d4eb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_550",
    "data-name": "Rectangle 550",
    width: 29.572,
    height: 6.157,
    transform: "translate(490.68 247.208)",
    fill: "#d6d4eb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_551",
    "data-name": "Rectangle 551",
    width: 37.545,
    height: 6.157,
    transform: "translate(524.827 247.208)",
    fill: "#d6d4eb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_552",
    "data-name": "Rectangle 552",
    width: 21.161,
    height: 6.157,
    transform: "translate(369.97 262.583)",
    fill: "#d6d4eb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_553",
    "data-name": "Rectangle 553",
    width: 37.983,
    height: 6.157,
    transform: "translate(469.149 262.583)",
    fill: "#d6d4eb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_554",
    "data-name": "Rectangle 554",
    width: 66.815,
    height: 6.157,
    transform: "translate(395.976 262.583)",
    fill: "#d6d4eb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_555",
    "data-name": "Rectangle 555",
    width: 47.907,
    height: 6.157,
    transform: "translate(369.97 277.957)",
    fill: "#d6d4eb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_556",
    "data-name": "Rectangle 556",
    width: 16.081,
    height: 6.157,
    transform: "translate(426.12 277.957)",
    fill: "#d6d4eb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_557",
    "data-name": "Rectangle 557",
    width: 31.624,
    height: 6.157,
    transform: "translate(449.703 277.957)",
    fill: "#d6d4eb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_558",
    "data-name": "Rectangle 558",
    width: 18.335,
    height: 6.157,
    transform: "translate(369.97 293.299)",
    fill: "#d6d4eb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_559",
    "data-name": "Rectangle 559",
    width: 40.237,
    height: 6.157,
    transform: "translate(395.235 293.299)",
    fill: "#d6d4eb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_560",
    "data-name": "Rectangle 560",
    width: 179.854,
    height: 53.492,
    transform: "translate(171.612 353.822)",
    fill: "#d6d4eb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_561",
    "data-name": "Rectangle 561",
    width: 34.147,
    height: 31.759,
    transform: "translate(176.389 357.456)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_562",
    "data-name": "Rectangle 562",
    width: 34.147,
    height: 9.42,
    transform: "translate(176.389 393.924)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_563",
    "data-name": "Rectangle 563",
    width: 34.147,
    height: 31.759,
    transform: "translate(219.889 371.619)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_564",
    "data-name": "Rectangle 564",
    width: 34.147,
    height: 9.42,
    transform: "translate(219.889 357.456)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_565",
    "data-name": "Rectangle 565",
    width: 34.147,
    height: 31.759,
    transform: "translate(266.754 357.456)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_566",
    "data-name": "Rectangle 566",
    width: 34.147,
    height: 9.42,
    transform: "translate(266.754 393.924)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_567",
    "data-name": "Rectangle 567",
    width: 34.147,
    height: 31.759,
    transform: "translate(310.22 371.619)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_568",
    "data-name": "Rectangle 568",
    width: 34.147,
    height: 9.42,
    transform: "translate(310.22 357.456)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_861",
    "data-name": "Group 861"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_859",
    "data-name": "Group 859",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1262",
    "data-name": "Path 1262",
    d: "M313.672,103.359H111.21V96.5a4.207,4.207,0,0,1,4.205-4.205H309.467a4.207,4.207,0,0,1,4.205,4.205Z",
    transform: "translate(262.931 218.2)",
    fill: "#140578"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_860",
    "data-name": "Group 860",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1263",
    "data-name": "Path 1263",
    d: "M313.672,94.34H111.21v85.89a5.521,5.521,0,0,0,5.517,5.517H308.121a5.521,5.521,0,0,0,5.517-5.517V94.34Zm-2.052,2.052V180.23a3.518,3.518,0,0,1-3.5,3.5H116.727a3.518,3.518,0,0,1-3.5-3.5V96.392Z",
    transform: "translate(262.931 223.047)",
    fill: "#140578"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_571",
    "data-name": "Rectangle 571",
    width: 123.065,
    height: 73.476,
    transform: "translate(444.657 328.388)",
    fill: "#d6d4eb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_572",
    "data-name": "Rectangle 572",
    width: 110.483,
    height: 7.502,
    transform: "translate(451.217 332.291)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_573",
    "data-name": "Rectangle 573",
    width: 110.483,
    height: 3.734,
    transform: "translate(451.217 344.301)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_574",
    "data-name": "Rectangle 574",
    width: 25.468,
    height: 8.781,
    transform: "translate(412.023 344.301)",
    fill: "#d6d4eb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_575",
    "data-name": "Rectangle 575",
    width: 23.752,
    height: 44.947,
    transform: "translate(451.217 351.434)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_576",
    "data-name": "Rectangle 576",
    width: 23.752,
    height: 44.947,
    transform: "translate(509.587 351.434)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1264",
    "data-name": "Path 1264",
    d: "M144.782,149.1h21.733V106.2H144.782Zm23.752,2.052h-25.8v-47h25.8Z",
    transform: "translate(337.453 246.241)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1265",
    "data-name": "Path 1265",
    d: "M161.618,149.1h21.733V106.2H161.618Zm23.785,2.052H159.6v-47h25.8Z",
    transform: "translate(377.339 246.241)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_577",
    "data-name": "Rectangle 577",
    width: 25.468,
    height: 8.781,
    transform: "translate(412.023 360.181)",
    fill: "#d6d4eb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_578",
    "data-name": "Rectangle 578",
    width: 25.468,
    height: 8.781,
    transform: "translate(412.023 376.094)",
    fill: "#d6d4eb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_579",
    "data-name": "Rectangle 579",
    width: 25.468,
    height: 8.781,
    transform: "translate(412.023 391.973)",
    fill: "#d6d4eb"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_872",
    "data-name": "Group 872"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_862",
    "data-name": "Group 862",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1266",
    "data-name": "Path 1266",
    d: "M179.964,24.21H106.421A17.67,17.67,0,0,0,90.777,50.081L85.024,60.544a3.136,3.136,0,0,0,3.97,4.407l13.726-5.82a16.553,16.553,0,0,0,3.667.4h73.543a17.663,17.663,0,0,0,.034-35.325",
    transform: "translate(200.065 57.239)",
    fill: "#f3a51c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_863",
    "data-name": "Group 863",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1267",
    "data-name": "Path 1267",
    d: "M102.725,33.9a6.258,6.258,0,1,1-6.258-6.258,6.246,6.246,0,0,1,6.258,6.258",
    transform: "translate(213.282 65.349)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_864",
    "data-name": "Group 864",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1268",
    "data-name": "Path 1268",
    d: "M109.505,33.9a6.258,6.258,0,1,1-6.258-6.258,6.246,6.246,0,0,1,6.258,6.258",
    transform: "translate(229.311 65.349)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_865",
    "data-name": "Group 865",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1269",
    "data-name": "Path 1269",
    d: "M116.285,33.9a6.258,6.258,0,1,1-6.258-6.258,6.246,6.246,0,0,1,6.258,6.258",
    transform: "translate(245.341 65.349)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_866",
    "data-name": "Group 866",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1270",
    "data-name": "Path 1270",
    d: "M123.065,33.9a6.258,6.258,0,1,1-6.258-6.258,6.246,6.246,0,0,1,6.258,6.258",
    transform: "translate(261.371 65.349)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_867",
    "data-name": "Group 867",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1271",
    "data-name": "Path 1271",
    d: "M261.154,77.44H187.611A17.66,17.66,0,0,0,169.949,95.1h0a17.739,17.739,0,0,0,2.019,8.209l-5.753,10.463a3.136,3.136,0,0,0,3.97,4.407l13.726-5.82a16.56,16.56,0,0,0,3.667.4h73.543A17.66,17.66,0,0,0,278.783,95.1h0A17.61,17.61,0,0,0,261.154,77.44",
    transform: "translate(392.02 183.09)",
    fill: "#f3a51c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_868",
    "data-name": "Group 868",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1272",
    "data-name": "Path 1272",
    d: "M183.915,87.118a6.258,6.258,0,1,1-6.258-6.258,6.246,6.246,0,0,1,6.258,6.258",
    transform: "translate(405.237 191.176)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_869",
    "data-name": "Group 869",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1273",
    "data-name": "Path 1273",
    d: "M190.695,87.118a6.258,6.258,0,1,1-6.258-6.258,6.246,6.246,0,0,1,6.258,6.258",
    transform: "translate(421.267 191.176)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_870",
    "data-name": "Group 870",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1274",
    "data-name": "Path 1274",
    d: "M197.475,87.118a6.258,6.258,0,1,1-6.258-6.258,6.246,6.246,0,0,1,6.258,6.258",
    transform: "translate(437.297 191.176)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_871",
    "data-name": "Group 871",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1275",
    "data-name": "Path 1275",
    d: "M204.255,87.118A6.258,6.258,0,1,1,198,80.86a6.246,6.246,0,0,1,6.258,6.258",
    transform: "translate(453.327 191.176)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_590",
    "data-name": "Rectangle 590",
    width: 118.355,
    height: 30.548,
    transform: "translate(27.116 284.181)",
    fill: "#9c2eff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1276",
    "data-name": "Path 1276",
    d: "M45.289,85.93l-7.368,20.32H32.235L27.66,93.634,22.95,106.25H17.264L9.93,85.93h5.551l4.811,13.76,4.979-13.76h5.013l4.845,13.76,4.945-13.76Z",
    transform: "translate(23.477 203.163)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1277",
    "data-name": "Path 1277",
    d: "M55.669,85.93,48.3,106.25H42.615L38.04,93.634,33.33,106.25H27.644L20.31,85.93h5.585l4.777,13.76,5.013-13.76h4.979l4.845,13.76,4.946-13.76Z",
    transform: "translate(48.018 203.163)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1278",
    "data-name": "Path 1278",
    d: "M66.025,85.93l-7.368,20.32H52.972L48.4,93.634l-4.71,12.616H38.034L30.7,85.93h5.551l4.777,13.76,5.013-13.76H51.02l4.845,13.76L60.81,85.93Z",
    transform: "translate(72.583 203.163)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1279",
    "data-name": "Path 1279",
    d: "M12.458,84.47v30.548m-6.258.034H18.749M6.2,84.47H18.749",
    transform: "translate(14.659 199.711)",
    fill: "none",
    stroke: "#38366e",
    strokeMiterlimit: 10,
    strokeWidth: 2.098
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1280",
    "data-name": "Path 1280",
    d: "M120.5,88.741l-10.362-2.792L99.78,83.19l2.759,10.362,2.792,10.362,5.686-5.686,11.842,11.842,3.8-3.8L114.818,94.427Z",
    transform: "translate(235.908 196.685)",
    fill: "#f2a61c"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1286",
    "data-name": "Path 1286",
    d: "M208.3,166.473a55.152,55.152,0,0,1-30.776,8.787,53.81,53.81,0,0,1-20-3.813c-1.462-.589-2.519-.7-3.888.451-22.352,18.7-53.244,12.941-67.473-12.508-.185-.329-.381-.653-.381-.653-6.615,1.5-12.976,3.559-19.487,4.31-21.451,2.467-40.794-2.259-56.2-18.378A36.263,36.263,0,0,1,8.187,96.642c9.544-11.844,22.173-18.291,37-20.336,7-.965,14.137-.867,21.63-1.277A29.557,29.557,0,0,1,81.536,54.063a31.017,31.017,0,0,1,26.218-2.831A72.816,72.816,0,0,1,120.729,29.37C139.823,7.821,163.706-2.139,192.472.4c26.645,2.351,47.264,15.108,62.077,37.235a66.356,66.356,0,0,1,10.636,27.494,3.1,3.1,0,0,0,2.831,2.97c11.156,2.5,21.653,6.759,29.961,14.669,3.732,3.553,7.1,4.05,11.8,3.888a35.812,35.812,0,0,1,36.744,32.682c1.462,18.141-12.45,35.363-31.192,37.327a18.025,18.025,0,0,0-12.826,6.465c-22.306,24.623-63.291,27.223-89.762,7.037C211.277,169.049,209.919,167.824,208.3,166.473Z",
    transform: "translate(1307.677 786.922)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1287",
    "data-name": "Path 1287",
    d: "M128.307,102.544a33.971,33.971,0,0,1-18.957,5.413,33.146,33.146,0,0,1-12.316-2.349,2.01,2.01,0,0,0-2.395.278c-13.768,11.519-32.8,7.971-41.561-7.7-.114-.2-.235-.4-.235-.4-4.075.925-7.993,2.192-12,2.655-13.213,1.52-25.127-1.391-34.618-11.32A22.337,22.337,0,0,1,5.048,59.531c5.879-7.3,13.658-11.267,22.793-12.526,4.309-.594,8.708-.534,13.323-.786A18.206,18.206,0,0,1,50.228,33.3a19.105,19.105,0,0,1,16.149-1.744A44.852,44.852,0,0,1,74.37,18.095C86.131,4.821,100.842-1.314,118.56.248,134.973,1.7,147.673,9.554,156.8,23.184a40.873,40.873,0,0,1,6.551,16.935,1.908,1.908,0,0,0,1.744,1.829c6.872,1.537,13.338,4.164,18.455,9.035,2.3,2.189,4.374,2.495,7.267,2.395A22.059,22.059,0,0,1,213.447,73.51,21.763,21.763,0,0,1,194.234,96.5a11.1,11.1,0,0,0-7.9,3.982c-13.74,15.167-38.985,16.768-55.29,4.334C130.144,104.132,129.307,103.377,128.307,102.544Z",
    transform: "translate(1498.309 917.273)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHostingdet);
export default __webpack_public_path__ + "static/media/hostingdet.0df35514203aaa3baece8c3cd5fc8e64.svg";
export { ForwardRef as ReactComponent };